export function strictSearchQuery(query) {
  return query.replace(/(^|[\s-])cbd(?=$|[\s-])/gi, '$1"CBD"');
}

const currentUrl = new URL(window.location.href);
const isSearchPage = currentUrl.pathname.replace(/\/$/, '').endsWith('/search');
const originalQuery = currentUrl.searchParams.get('q') || '';
const strictQuery = strictSearchQuery(originalQuery);
if (isSearchPage && strictQuery !== originalQuery) {
  currentUrl.searchParams.set('q', strictQuery);
  currentUrl.searchParams.delete('page');
  window.location.replace(currentUrl.toString());
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const action = new URL(form.action, location.origin);
  if (!action.pathname.replace(/\/$/, '').endsWith('/search')) return;
  const input = form.querySelector('input[name="q"]');
  if (!(input instanceof HTMLInputElement)) return;
  const query = strictSearchQuery(input.value);
  if (query === input.value) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const url = new URL(form.action, location.origin);
  for (const [key, value] of new FormData(form)) {
    if (typeof value === 'string') url.searchParams.set(key, value);
  }
  url.searchParams.set('q', query);
  url.searchParams.delete('page');
  window.location.href = url.toString();
}, true);
